import { render, staticRenderFns } from "./UpdateQuestionnaireModal.vue?vue&type=template&id=77131284"
import script from "./UpdateQuestionnaireModal.vue?vue&type=script&lang=ts"
export * from "./UpdateQuestionnaireModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports